import {useMemo} from 'react'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useGetAverageAge} from '../../core/_query'
import {CategoryTreatmentBarChart} from './CategoryTreatmentBarChart'

const AverageAgeChart = () => {
  const {state} = useQueryRequest()
  const {data: trendCategories} = useGetAverageAge({...state, set_is_job_therapist: false})

  const sorted = useMemo(() => {
    return (trendCategories?.response?.data || []).reverse()
  }, [trendCategories])

  const arrayOfSeriesscategory = useMemo(() => {
    return sorted?.map((x) => x?.total || 0)
  }, [trendCategories])

  const arrayOfLabelscategory = useMemo(() => {
    return sorted?.map((x) => x.age_range)
  }, [trendCategories])

  return (
    <CategoryTreatmentBarChart
      className='shadow-wit-2'
      color='primary'
      title='Rata - Rata Umur'
      isCurrency={false}
      series={[
        {
          name: 'Total',
          data: arrayOfSeriesscategory,
        },
      ]}
      categories={arrayOfLabelscategory}
    />
  )
}

export {AverageAgeChart}
